'use client';

import React, { useEffect, useRef, useState } from 'react';
import Button from '~/components/button';
import sanitizeHtml from '~/utils/sanitize-html';

import styles from './styles.module.css';

const COOKIES_HEIGHT_VAR = '--cookies-height';

interface Props {
  description: string | null;
}

const Cookies: React.FC<Props> = ({ description }) => {
  const [isShowCookies, setIsShowCookies] = useState<boolean>();
  const cookiesRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const hasCookie = document.cookie.split('; ').some((item) => item.trim().startsWith('isAccept=true'));
    if (!hasCookie) {
      setIsShowCookies(true);
    }
  }, []);

  // Высота баннера нужна фиксированным элементам внизу экрана (кнопка «Наверх»)
  useEffect(() => {
    const container = cookiesRef.current;
    if (!isShowCookies || !container) return;

    const root = document.documentElement;
    const observer = new ResizeObserver(() => {
      root.style.setProperty(COOKIES_HEIGHT_VAR, `${container.offsetHeight}px`);
    });
    observer.observe(container);

    return () => {
      observer.disconnect();
      root.style.removeProperty(COOKIES_HEIGHT_VAR);
    };
  }, [isShowCookies]);

  const setCookieHandler = (): void => {
    const date = new Date();
    date.setTime(date.getTime() + 180 * 24 * 60 * 60 * 1000);
    //Установка cookie на 180 дней
    document.cookie = `isAccept=true; expires=${date.toUTCString()}`;

    cookiesRef.current?.classList.add(styles.containerHidden);
    document.documentElement.style.removeProperty(COOKIES_HEIGHT_VAR);

    setTimeout(() => {
      setIsShowCookies(false);
    }, 500);
  };

  if (!isShowCookies) {
    return null;
  }

  return (
    <div className={styles.container} ref={cookiesRef}>
      <div className={styles.cookiesContainer}>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(description || '<p>Принять cookie файлы</p>') }}
        />
        <Button onClick={setCookieHandler} className={styles.button} title="Понятно" />
      </div>
    </div>
  );
};

export default Cookies;
